// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2bKg5","form":"styles_form__35kH8"};